
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Image, Upload, Trash2, Pencil } from 'lucide-react';

interface MediaLibraryProps {
  searchQuery: string;
}

const MediaLibrary = ({ searchQuery }: MediaLibraryProps) => {
  // Mock data - would typically come from an API
  const mediaItems = [
    { id: 1, name: 'hero-image.jpg', type: 'image', size: '1.2 MB', uploaded: '2023-10-15', url: '/lovable-uploads/89c00e6e-572d-4a16-9b34-42899f587039.png' },
    { id: 2, name: 'team-photo.jpg', type: 'image', size: '2.4 MB', uploaded: '2023-09-20', url: '/lovable-uploads/86f6b760-1fe5-489f-bf0c-b63246d665e9.png' },
    { id: 3, name: 'product-demo.mp4', type: 'video', size: '8.7 MB', uploaded: '2023-11-05', url: '' },
    { id: 4, name: 'case-study.pdf', type: 'document', size: '3.1 MB', uploaded: '2023-12-01', url: '' },
    { id: 5, name: 'logo.svg', type: 'image', size: '0.2 MB', uploaded: '2023-08-10', url: '/lovable-uploads/f62cf214-d7ba-45a4-9fd0-456ece689b7f.png' },
    { id: 6, name: 'product-screenshot.png', type: 'image', size: '0.8 MB', uploaded: '2023-11-15', url: '/lovable-uploads/eabe9c4c-7a1b-4bcb-b157-9a91bb9b7502.png' },
  ];
  
  const filteredMedia = searchQuery 
    ? mediaItems.filter(item => 
        item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.type.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : mediaItems;
  
  return (
    <div>
      <div className="mb-6">
        <Button className="w-full sm:w-auto">
          <Upload className="h-4 w-4 mr-2" />
          Upload Media
        </Button>
      </div>
      
      {filteredMedia.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredMedia.map((item) => (
            <Card key={item.id} className="overflow-hidden">
              <div className="aspect-square bg-muted relative group">
                {item.type === 'image' && item.url ? (
                  <img 
                    src={item.url} 
                    alt={item.name}
                    className="w-full h-full object-cover" 
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-muted">
                    <Image className="h-12 w-12 text-muted-foreground" />
                  </div>
                )}
                <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                  <Button size="icon" variant="ghost" className="text-white">
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button size="icon" variant="ghost" className="text-white">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
              <CardContent className="p-3">
                <p className="font-medium text-sm truncate" title={item.name}>{item.name}</p>
                <p className="text-xs text-muted-foreground">{item.size} • {item.uploaded}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 bg-muted/30 rounded-lg">
          <Image className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
          <h3 className="font-medium">No media found</h3>
          <p className="text-sm text-muted-foreground">Upload media or try a different search</p>
        </div>
      )}
    </div>
  );
};

export default MediaLibrary;
